import { render, staticRenderFns } from "./FiltrosTabLogs.vue?vue&type=template&id=6aaf7924"
import script from "./FiltrosTabLogs.vue?vue&type=script&lang=js"
export * from "./FiltrosTabLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports